import React from 'react';
import { images } from '../data/images';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">
            <h1 className="section-title">About Us</h1>
            <p className="about-subtitle">
              We are a team of dedicated structural engineers committed to delivering excellence in every project.
            </p>
          </div>
        </div>
      </section>

      <section className="about-content section">
        <div className="container">
          <div className="about-grid grid grid-2">
            <div className="about-text">
              <h2>Our Story</h2>
              <p>
                Founded with a vision to revolutionize structural engineering, StructIcon has grown
                into a leading provider of innovative structural solutions. Our journey began with
                a simple mission: to deliver excellence in every project we undertake.
              </p>
              <p>
                Today, we stand proud as a team of dedicated professionals committed to pushing
                the boundaries of what's possible in structural engineering.
              </p>
              <div className="about-stats">
                <div className="stat-item">
                  <span className="stat-number">15+</span>
                  <span className="stat-label">Years Experience</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">500+</span>
                  <span className="stat-label">Projects Completed</span>
                </div>
              </div>
            </div>
            <div className="about-image">
              <img src={images.aboutCompany} alt="Our Office" />
            </div>
          </div>
        </div>
      </section>

      <section className="mission-vision section">
        <div className="container">
          <div className="mission-vision-grid grid grid-2">
            <div className="mission card">
              <div className="mission-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 15V17M12 7V13M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h2>Our Mission</h2>
              <p>
                To provide innovative, sustainable, and cost-effective structural solutions
                that exceed client expectations while maintaining the highest standards of
                safety and quality.
              </p>
            </div>
            <div className="vision card">
              <div className="vision-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2.458 15C3.732 17.942 6.113 20 9 20C9.552 20 10 19.552 10 19V18C10 16.343 11.343 15 13 15H14C15.657 15 17 16.343 17 18V19C17 19.552 17.448 20 18 20C20.887 20 23.268 17.942 24.542 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h2>Our Vision</h2>
              <p>
                To be the global leader in structural engineering, known for our technical
                excellence, innovation, and commitment to sustainable development.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="team section">
        <div className="container">
          <h2 className="section-title">Our Leadership Team</h2>
          <div className="team-grid grid grid-3">
            <div className="team-member card">
              <div className="member-image">
                <img src={images.team.member1} alt="Team Member" />
              </div>
              <div className="member-info">
                <h3>John Doe</h3>
                <p className="member-role">Chief Executive Officer</p>
                <p className="member-bio">
                  With over 20 years of experience in structural engineering, John leads our team with expertise and vision.
                </p>
              </div>
            </div>
            <div className="team-member card">
              <div className="member-image">
                <img src={images.team.member2} alt="Team Member" />
              </div>
              <div className="member-info">
                <h3>Jane Smith</h3>
                <p className="member-role">Technical Director</p>
                <p className="member-bio">
                  Sarah brings innovative solutions to complex structural challenges with her extensive knowledge.
                </p>
              </div>
            </div>
            <div className="team-member card">
              <div className="member-image">
                <img src={images.team.member3} alt="Team Member" />
              </div>
              <div className="member-info">
                <h3>Mike Johnson</h3>
                <p className="member-role">Project Manager</p>
                <p className="member-bio">
                  Michael ensures the successful delivery of our projects through effective management.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 